<template>
	<component :is="name" :dataQuery="dataQuery"></component>
</template>

<script>
  import CustomersFrequency from '@/modules/neodash/containers/customers-frequency/index.vue';

  import {momentMixin} from '@/modules/neodash/mixins';

  import {FILTERS_GET_VALUES} from '@/modules/neodash/store/modules/filters/types';
  import {mapGetters} from 'vuex';

  export default {
    props: {
      name: {
        type: String,
        required: true
      }
    },

    mixins: [momentMixin],

    computed: {
      ...mapGetters({
        filtersValues: FILTERS_GET_VALUES
      }),

      dataQuery() {
        return {
          ...this.filtersValues,
          name: this.name
        };
      }
    },

    components: {
      CustomersFrequency
    }
  };
</script>

<style lang="scss" scoped>
</style>
